module.exports = __webpack_public_path__ + "img/182.bb4c6bb9.png";